import { helper } from 'lib/helper';
import bookingModel from 'models/booking.model';
import usersModel from 'models/users.model';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, CardHeader, Container, Row, Table , Col } from 'reactstrap'


const BookingDetails = ({user , isLoading }) => {
    const {id} = useParams();
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [filteredBookings , setFilteredBookings] = useState([])
    const navigate = useNavigate();

    useEffect(() => {

      const getBookingDetails = async () => {
        // const data = await usersModel.getSpecificUserBookings(id);
        const data = await usersModel.getSpecificUserBookings(id);
        console.log('------------------->',data)
        setFilteredBookings(data?.bookings)
      }

      getBookingDetails()
    },[])

    const handleDelete = async (id) => {
      const result = await helper.sweetalert.confirm(
        "Are you sure you want to delete this booking?",
        "info",
        true
      );
      if (result.isConfirmed) {
        try {
          await bookingModel.deleteBooking(id);
          const updatedList = filteredBookings.filter((item) => item._id !== id);
          setFilteredBookings(updatedList);
          helper.sweetalert.toast("Booking deleted successfully!");
        } catch (error) {
          helper.sweetalert.toast(error.response?.data?.message, "warning");
        } 
      }
    };


  return (
    <Container className="">
    {!isLoading &&  filteredBookings.length < 1 ? <h3 className="text-center">No Booking found</h3> :  (
      <Row>
        
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0 d-flex justify-content-between align-items-center">
              <h3 className="mb-0">User Bookings</h3>
            </CardHeader>
           
          <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">S.No</th>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Mobile</th>
                  <th scope="col">Booking ID</th>
                  <th scope="col">Experience Time</th>
                  <th scope="col">Booked On</th>
                  <th scope="col">Payment Mode</th>
                  <th scope="col">Total Payment</th>
                  <th scope="col">Experience Details</th>
                  <th scope="col">Status</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                { filteredBookings?.map((item, index) => (
                  <tr key={item._id}>
                    <td>{index + 1}</td>
                    <td>{item?.user?.firstName}</td>
                    <td>{item?.user?.lastName}</td>
                    <td>{item?.user?.mobileNo}</td>
                    <td>{item?._id}</td>
                    <td>{item?.startTime} - {item?.endTime}</td>
                    <td>{new Date(item?.bookingDate).toLocaleDateString('en-GB')}</td>
                    <td>{item?.transaction?.mode}</td>
                    <td>₹{item?.transaction?.amount?.toFixed(0) || 0}</td>
                    <td>{item?.experience?.title}</td>
                    <td>{item?.status}</td>
                    <td>
                      <Button
                        color="info"
                        size="sm"
                        className="mr-2"
                        onClick={() => navigate(`/admin/bookings/view/${item?._id}`)}
                      >
                        <i className="fa-solid fa-eye"></i>
                      </Button>
                      <Button
                        color="warning"
                        size="sm"
                        className="mr-2"
                        onClick={() => navigate(`/admin/bookings/edit/${item?._id}`)}
                      >
                        <i className="fa-regular fa-pen-to-square"></i>
                      </Button>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(item._id)}
                      >
                        <i className="fa-solid fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        </div>
      </Row>
    )}
  </Container>
  )
}

export default BookingDetails